import { useMemo } from 'react'

import { Flex } from 'components/common/flex/Flex'
import { AnimatedTitle } from 'components/heroBanner/animatedTitle/AnimatedTitle'
import styles from 'components/heroBanner/HeroBanner.module.scss'

export const HeroBanner = () => {
  
  // const { data: completedProjectsCount } = useFetchCompletedProjectsCount() /* Not considering collider api as of now, will be added back once we new api available for integratation. */
  
  
  const completedProjectsCountValue = useMemo(() => {
    const completedProjectsCount = { prioritization: 94 } /* Mocked data for now, will be removed once we new api available for integratation. */

    if (typeof completedProjectsCount?.prioritization === 'number') {
      return completedProjectsCount.prioritization
    }
    return 0
  }, [])

  return (
    <Flex direction="column" align="center" className={styles.container}>
      <div className={styles.content}>
        <AnimatedTitle />
        <Flex gap={183} className={styles.section}>
          <p className={styles.description}>
            {'In a world where great ideas abound, prioritization\nkeeps us focused on our goals.'}
          </p>
          <Flex gap={16} align="center">
            <Flex className={styles.counterWrapper}>
              {String(completedProjectsCountValue)
                .padStart(4, '0')
                .split('')
                .map((digit, index) => (
                  <div className={styles.digitWrapper} key={index}>
                    <p className={styles.counterText} color="#fff">
                      {digit}
                    </p>
                  </div>
                ))}
            </Flex>
            <p className={styles.counterLabel}>
              Projects
            </p>
          </Flex>
        </Flex>
      </div>
      <div
        style={{ background: 'linear-gradient(180deg, #A60039 0%, #75192A 62.53%)' }}
        className="flex-1 w-[150%] px-[25%] mt-64"
      >
        <svg width="100%" height="400" viewBox="0 0 100 100" preserveAspectRatio="none" className="-mt-[400px]">
          <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
        </svg>
      </div>
    </Flex>
  )
}
